import { ReducerState } from '../../store.types';

export const hyperPaySelector = ({ hyperPay }: ReducerState) => hyperPay;
